export default __webpack_public_path__ + "static/techno-ad4f2e6429e036947713d7cae7c7550d.png";